// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3fT-C","gfeWrapper":"CalendarEvent_gfeWrapper__BpkcA"};